export const phoneMask = '+7 (___) ___-__-__'

// Выделяем чистые 10 цифр номера из любой строки
export const extractPhoneDigits = (input: string): string => {
  const digitsOnly = input.replace(/\D/g, '')

  // 1. Обработка двойного префикса (77/78) при вставке/автозаполнении
  // Если цифр >= 12 и начало 77/78, берем цифры с 3-й по 12-ю (индексы 2..12)
  if (digitsOnly.length >= 12 && (digitsOnly.startsWith('77') || digitsOnly.startsWith('78'))) {
    return digitsOnly.slice(2, 12)
  }

  // 2. Если цифр >= 11 (стандартный формат 8900... или 7900...)
  if (digitsOnly.length >= 11) {
    const first11 = digitsOnly.slice(0, 11)
    // Если начинается с 7 или 8 — это код страны, убираем его
    if (first11.startsWith('7') || first11.startsWith('8')) {
      return first11.slice(1)
    }
    // Если не начинается на 7/8 (например 5...), то просто идем дальше
    // и возьмем первые 10 цифр в конце функции.
  }

  // 3. Если цифр 10 — возвращаем как есть
  if (digitsOnly.length === 10) {
    return digitsOnly
  }

  // 4. Если цифр меньше 10 (частичный ввод)
  // Если начали вводить "+7" (строка "7" или "8"), но цифр мало — убираем префикс,
  // чтобы не забивать маску цифрой "7"
  if (digitsOnly.length >= 2 && (digitsOnly.startsWith('7') || digitsOnly.startsWith('8'))) {
    return digitsOnly.slice(1).slice(0, 10)
  }

  // Иначе просто возвращаем что есть (до 10 символов)
  return digitsOnly.slice(0, 10)
}

// Форматируем по нужной маске ввод любого (в корректном виде) телефона
export const formatAnyInputToPhoneMask = (pastedText: string) => {
  const local10 = extractPhoneDigits(pastedText)

  // Заменяем символы '_' на цифры из строки
  let result = ''
  let digitIndex = 0

  for (let i = 0; i < phoneMask.length; i++) {
    if (phoneMask[i] === '_' && digitIndex < local10.length) {
      result += local10[digitIndex++]
    } else {
      result += phoneMask[i]
    }
  }

  return result
}

export const dateMask = '__.__.____'
export const dateReplacement = { _: /\d/ }
